
(function () {
  'use strict';

  angular
    .module('managePairing')
    .controller('PairingBulkUpdateResponseCtrl', PairingBulkUpdateResponseCtrl);

  function PairingBulkUpdateResponseCtrl($uibModalInstance, modalParams) {
    var vm = this;

    vm.model = {
      pairingUpdateResponse:modalParams,
      resultList:[]
    };


    vm.onCloseClick = function () {
      $uibModalInstance.close();
    };

    vm.exportResultAsCsv = function () {
      if(vm.model.pairingUpdateResponse.bulkResponse.length>0) {
        createResponseList();
        alasql("SELECT [patternName] as [Pattern Name],[patternStartDate] as [Start Date],[success] as [Status] INTO XLSX('pairingBulkUpdateResponse.xlsx',{headers:true}) FROM ? ", [vm.model.resultList]);
        clearData();
      }


    };

    function createResponseList() {
      for (var i = 0; i < vm.model.pairingUpdateResponse.bulkResponse.length; i++) {
        var resultList = [];

        resultList.patternName = vm.model.pairingUpdateResponse.bulkResponse[i].patternName;
        resultList.patternStartDate = vm.model.pairingUpdateResponse.bulkResponse[i].patternStartDate;
        resultList.success = vm.model.pairingUpdateResponse.bulkResponse[i].success;

        vm.model.resultList.push(resultList);
      }

    };

  }
}());
